import { FC, useEffect } from "react";
import { useDispatch } from "react-redux";
import NetInfo from '@react-native-community/netinfo';
import { networkConnection } from "@fkhplus/common/src/modules/network/actions";

const NetworkStatus: FC = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        const unsubscribe = NetInfo.addEventListener(state => {
            if (state.isConnected) {
                dispatch(networkConnection(state.isConnected))
            } else {
                dispatch(networkConnection(false))
            }
        });
        return () => unsubscribe();
    }, []);

    return (
        null
    )
}

export default NetworkStatus;